




























import { Component, Vue, Prop } from 'vue-property-decorator';
import { Tests } from '@/models/jobDetail/tests';

@Component({})
export default class JobTestSummary extends Vue {
  @Prop({ type: Object, default: null }) public jobTests!: Tests;

  get passedTestCount(){
    return this.jobTests.passed;
  }

  get failedTestCount(){
    return this.jobTests.failed;
  }
}

